<template>
    <div :class="centeredFrame ? 'about-box-centered' : 'about-box'">
        <div v-if="centeredFrame" class="about-header-centered">
            <img src="@/assets/images/aboutus/frame.webp" class="absolute_image_centered" />
            <span class="about-title-centered">{{ title }}</span>
        </div>
        <div class="about-header" v-else>
            <img src="@/assets/images/aboutus/frame.webp" class="absolute_image" />
            <span class="about-title">{{ title }}</span>
        </div>
        <div v-html="content"></div>
    </div>
</template>

<script>
export default {
    props: ['title', 'content', 'centeredFrame']
}
</script>

<style scoped>
.about-box {
    position: relative;
    padding: 50px;
    min-height: 250px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    border-radius: 15px;
    border: 2px solid #c8a15a;
}

/* Default Header (Not Centered) */
.about-header {
    position: absolute;
    top: -50px;
    right: -5%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 5px 20px;
    border-radius: 20px;
    font-weight: bold;
    color: white;
    font-size: 1.1rem;
}

.absolute_image {
    width: 120px;
    height: 80px;
    object-fit: contain;
    position: relative;
    z-index: -1;
}

.about-title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
}

/* Centered Frame */
.about-box-centered {
    position: relative;
    padding-top: 80px;
    min-height: 300px;
    display: flex;
    flex-direction: column;

    border-radius: 15px;
    border: 2px solid #c8a15a;
}
.about-header-centered {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 300px;
    height: 150px;
}

.absolute_image_centered {
    width: 100%;
    height: 120px;
    object-fit: contain;
    position: relative;
    z-index: -1;
}

.about-title-centered {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    font-size: 1.2rem;
    font-weight: bold;
    color: white;
}

::v-deep(li) {
    font-size: 22px;
    font-weight: 400;
    margin-bottom: 3px;
    text-align: start;
}
</style>
